function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { userCardApi, userHrUpdateApi } from '@/api/user';
import { jobsCreate } from '@/api/enterprise';
export default {
  name: 'EditUser',
  components: {
    selectMember: function selectMember() {
      return import('@/components/form-common/select-member');
    },
    selectDepartment: function selectDepartment() {
      return import('@/components/form-common/select-department');
    }
  },
  props: {
    userId: {
      type: [String, Number],
      default: 0
    }
  },
  data: function data() {
    return {
      memberShow: false,
      loading: false,
      departmentShow: false,
      drawer: false,
      direction: 'rtl',
      activeName: 0,
      ruleForm: {
        name: ''
      },
      rules: {},
      options: [],
      value1: '',
      userInfo: null,
      pageData: {},
      frames: [],
      // 部门
      superiorFrame: [],
      // 上级部门
      superiorUser: [],
      // 上级人员
      formBoxConfig: {
        title: this.$t('setting.edit.addmembers'),
        width: '500px',
        method: 'post',
        action: '/user/create'
      },
      rolesConfig: [],
      defaultCheckedKeys: [],
      // 权限选中
      rolesList: {},
      mastart_id: '',
      // 主部门,
      rangeUser: [],
      choiceEdit: 0,
      treeData: [],
      propsPos: {
        value: 'id',
        label: 'name',
        multiple: false,
        checkStrictly: true
      }
    };
  },
  watch: {
    userId: {
      handler: function handler(nVal, oVal) {
        if (nVal) {
          this.getUserinfo();
          this.getTreeData();
        }
      },
      deep: true
    },
    frames: {
      handler: function handler(nVal, oVal) {
        var _this = this;
        if (nVal) {
          var preMastartId = this.mastart_id;
          nVal.forEach(function (el) {
            if (el.is_mastart) {
              _this.mastart_id = el.id;
              _this.superiorFrame = _this.superiorFrame.map(function (i) {
                return i.id === preMastartId ? el : i;
              });
            }
          });
        }
      },
      deep: true
    }
  },
  methods: {
    handleClose: function handleClose() {
      this.userInfo = null;
      this.drawer = false;
      this.$parent.userId = '';
    },
    open: function open() {
      this.drawer = true;
    },
    getStockSymbols: function getStockSymbols(stocks) {
      var symbols = [];
      stocks.forEach(function (stock) {
        symbols.push(stock.name);
      });
      return symbols;
    },
    unique: function unique(arr) {
      var res = new Map();
      return arr.filter(function (arr) {
        return !res.has(arr.id) && res.set(arr.id, 1);
      });
    },
    // 获取组件架构详情
    getUserinfo: function getUserinfo() {
      var _this2 = this;
      if (!this.userId) return;
      userCardApi(this.userId).then(function (res) {
        _this2.userInfo = res.data;
        _this2.superiorUser = [];
        _this2.rangeUser = [];
        if (res.data.superior_uid > 0 && res.data.superior_name) {
          _this2.superiorUser.push({
            name: res.data.superior_name,
            value: res.data.superior_uid,
            avatar: res.data.superior_avatar
          });
        }
        if (res.data.job) {
          _this2.userInfo.position = [res.data.job];
        } else {
          _this2.userInfo.position = [];
        }
        // if (res.data.scope.length > 0) {
        //   res.data.scope.map((value) => {
        //     value.frames.map((val) => {
        //       this.rangeUser.push(val)
        //     })
        //   })
        // }
        _this2.frames = res.data.frames;
        var mastart_id = ''; // 主部门id
        var mastartData = {}; // 主部门数据
        _this2.frames.forEach(function (el) {
          if (el.is_mastart) {
            mastart_id = el.id;
            mastartData = el;
            _this2.mastart_id = el.id;
          }
        });
        var result = _this2.superiorFrame.some(function (item) {
          if (item.id == mastart_id) {
            return true;
          }
        });
        if (!result) {
          _this2.superiorFrame.push(mastartData);
        }
        _this2.pageData = res.data;
        // this.arrToObj()
      });
    },
    // 获取职位tree数据
    getTreeData: function getTreeData() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var result;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return jobsCreate();
            case 2:
              result = _context.sent;
              _this3.treeData = result.data.tree;
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    //  选择部门
    handleOpen: function handleOpen() {
      this.$refs.selectDepartment.handlePopoverShow();
    },
    // 选择部门回调
    changeMastart: function changeMastart(data) {
      this.frames = data;
    },
    // 选择人员回调
    getSelectList: function getSelectList(data) {
      this.superiorUser = data;
    },
    handlesuperiorOpen: function handlesuperiorOpen() {
      this.$refs.selectMember.handlePopoverShow();
    },
    // 保存
    onSubmit: function onSubmit() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var superior_frame_id, frames, frame_id, mastart_id;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              superior_frame_id = null;
              frames = [];
              frame_id = []; // 部门id
              mastart_id = ''; // 主部门id
              _this4.frames.forEach(function (el) {
                frame_id.push(el.id);
                if (el.is_mastart) {
                  mastart_id = el.id;
                }
              });
              if (_this4.superiorUser.length > 0) {
                superior_frame_id = _this4.superiorUser[0].value;
              }
              if (!(mastart_id === '')) {
                _context2.next = 8;
                break;
              }
              return _context2.abrupt("return", _this4.$message.error(_this4.$t('setting.edit.text3')));
            case 8:
              if (frame_id.length == 1 && mastart_id == '') {
                _this4.userInfo.mastart_id = frame_id[0];
              } else {
                _this4.userInfo.mastart_id = mastart_id;
              }
              _this4.userInfo.frame_id = frame_id;
              _this4.userInfo.superior_uid = superior_frame_id;
              if (_this4.userInfo.position && _this4.userInfo.position.length > 0) {
                _this4.userInfo.position = _this4.userInfo.position[_this4.userInfo.position.length - 1];
              }
              if (_this4.rangeUser.length > 0) {
                _this4.rangeUser.map(function (value) {
                  frames.push(value.id);
                });
              }
              _this4.userInfo.frames = frames;
              _this4.loading = true;
              _context2.next = 17;
              return userHrUpdateApi(_this4.userId, _this4.userInfo);
            case 17:
              _this4.drawer = false;
              _this4.loading = false;
              _context2.next = 21;
              return _this4.$parent.getTableList();
            case 21:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    // 设为主部门
    handleDepartment: function handleDepartment(item, index) {
      this.$refs["popover-".concat(index)][0].doClose();
      this.frames.forEach(function (el) {
        el.is_mastart = false;
      });
      item.is_mastart = true;
      this.mastart_id = item.id;
    },
    // 删除所在部门
    handleDeleteDep: function handleDeleteDep(index) {
      this.$refs["popover-".concat(index)][0].doClose();
      this.frames.splice(index, 1);
    },
    handleDelSuperior: function handleDelSuperior(index) {
      this.$refs["popoverSuperior-".concat(index)][0].doClose();
      this.superiorUser.splice(index, 1);
    },
    cardTag: function cardTag(index) {
      this.rangeUser.splice(index, 1);
    }
  }
};